import { Injectable } from '@angular/core';
import { Observable,  of } from 'rxjs';
import { EzoTmpl, EzoTmplData } from '../../../interfaces/masters/ezo-tmpl';
import { EzoTmplApi } from '../api/ezo-tmpl.api';




@Injectable()
export class EzoTmplService extends EzoTmplData {

    constructor(private api: EzoTmplApi) {
      super();
    }
  
  
    list(url: string): Observable<EzoTmpl[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<EzoTmpl>{
        return this.api.getById(url);
    }
  
    create(url: string, data:EzoTmpl): Observable<EzoTmpl[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:EzoTmpl): Observable<EzoTmpl> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  